import { POST } from '@wellsfargo/ecpfs-authority'

export const CREATE_USER_ID_PATH = 'register/details.json'

export function createUserId(userId) {
	return POST(CREATE_USER_ID_PATH, userId)
}
